import { consts } from '../../services/_consts';
import React from 'react';

export { Modal } from './Modal';
export { Table4, Col, ColInput, ColBtn } from "./Table4";
export { Table, Column } from "./Table3";
export { Dropdown } from './Dropdown';
export { Rating } from './Rating';
export { ImgUploder } from './ImgUploder';
export { ErrorBoundary } from './ErrorBoundary';

//export const Div = ({ children, onBlur, className = '' }) =>
//    <div className={className} contenteditable="true" onBlur={onBlur}>{children}</div>
export class Div extends React.Component {
    constructor(props) {
        super(props);
        this.state = { onfocuse: false };
    }
    render() {
        return this.state.onfocuse ?
            <div className={this.props.className} contentEditable
                onFocus={e => { this.setState({ onfocuse: true }); }}
                onBlur={e => { this.setState({ onfocuse: false }); this.props.onBlur(e); }}>{this.props.children}</div>
            :
            <div className={this.props.className} contentEditable
                dangerouslySetInnerHTML={{ __html: this.props.children }}
                onFocus={e => { this.setState({ onfocuse: true }); }}
                onBlur={e => { this.setState({ onfocuse: false }); this.props.onBlur(e); }}></div>
    }
}

export class P extends React.Component {
    constructor(props) {
        super(props);
        this.state = { onfocuse: false };
    }
    render() {
        return this.state.onfocuse ?
            <p className={this.props.className} contentEditable
                onFocus={e => { this.setState({ onfocuse: true }); }}
                onBlur={e => { this.setState({ onfocuse: false }); this.props.onBlur(e); }}>{this.props.children}</p>
            :
            <p className={this.props.className} contentEditable
                dangerouslySetInnerHTML={{ __html: this.props.children }}
                onFocus={e => { this.setState({ onfocuse: true });  }}
                onBlur={e => { this.setState({ onfocuse: false }); this.props.onBlur(e); }}></p>
    }
}


export const Span = ({ children, onBlur, className = '', style = {} }) =>
    <span className={className} style={style} contenteditable="true" onBlur={onBlur}>{children}</span>

export const Span2 = ({ children, showCondition = true, icon, className = '', removable, onBlur, onRemove, style = {} }) => {
    const style1 = {
        las: {
            margin: '0 4px',
            fontSize: '24px',
        }
    }
    return (
        showCondition && <div style={{ display: 'flex' }} >
            <i className={icon} style={style1.las}></i>
            <Span className={className} style={style} onBlur={onBlur}>{children}</Span>
            {removable && <button onClick={onRemove} className="remove-btn">{consts.remove}</button>}
        </div>)
}

export const H1 = ({ children, onBlur, className = '' }) =>
    <h1 className={className} contenteditable="true" onBlur={onBlur}>{children}</h1>


export const Switch = ({ text, onChange, defaultChecked, icon }) =>
    <div className="form-check form-switch">
        <input className="form-check-input" type="checkbox" role="switch" onChange={onChange} checked={defaultChecked} defaultChecked={defaultChecked} />
        {icon}
        <label className="form-check-label w-10" >{text}</label>
    </div>

export const Opts = ({ i, onUp, onDown, onRemove, length = 9999999, type = 'upDown' }) =>
    <div className="btn-group btn-group-sm opts ltr" role="group" >
        {i > 0 && <button type="button" className="btn btn-outline-primary px-2 py-0" onClick={() => onUp('educations', i)}>{type == 'upDown' ? <i className="las la-angle-up"></i> : <i className="las la-angle-left"></i>}</button>}
        {i < length - 1 && <button type="button" className="btn btn-outline-primary px-2 py-0" onClick={() => onDown('educations', i)}>{type == 'upDown' ? <i className="las la-angle-down"></i> : <i className="las la-angle-right"></i>}</button>}
        <button type="button" className="btn btn-outline-danger px-2 py-0" onClick={() => onRemove('educations', i)}><i className="las la-trash-alt"></i></button>
    </div>



        //export const P = ({ children, onBlur, className = '' }) => {

//    var onfocuse = false;
//    return (onfocuse ? <>{children}</>:
//        <p className={className} contentEditable
//            onFocus={e => { onfocuse = true; }}
//            onBlur={e => { onfocuse = false; onBlur(e); }}>{children}</p>)
//}